import React, { useState } from "react";

/**
 * The approval and repair-link block of an inspection record's detail
 * (SPEC-CIS-COCKPIT-DAY-REDESIGN-P2-001 2.3, 2.4): who approved it and when,
 * Reopen / Approve, and the link to the earlier defect record with the undo
 * "Not a repair check of #N". `view` is api/recordReview.js#recordReviewView;
 * `onReview(op, view, target)` resolves { ok, message }. `phone` swaps the
 * class names for the phone layout.
 */
export default function RecordReview({ view, onReview, phone = false }) {
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState("");
  if (!view) return null;
  const cls = phone
    ? { box: "ph-card", text: "ph-small", btn: "ph-btn sec", note: "ph-small" }
    : { box: "", text: "", btn: "btn off", note: "" };

  async function run(op, target) {
    if (pending || !onReview) return;
    setPending(true);
    setMessage("");
    let outcome;
    try {
      outcome = await onReview(op, view, target);
    } catch (err) {
      outcome = { ok: false, message: (err && err.message) || "request failed" };
    }
    setPending(false);
    if (outcome && !outcome.ok) setMessage(outcome.message || "The change could not be saved.");
  }

  const repair = view.repair;
  return (
    <div data-testid="record-review" className={cls.box} style={phone ? undefined : { display: "flex", flexDirection: "column", gap: 6, fontSize: 12 }}>
      <span data-testid="record-approval" className={cls.text} style={phone ? undefined : { color: view.approved ? "var(--ok)" : "var(--t2)" }}>{view.approvalText}</span>
      {repair.text ? <span data-testid="record-repair" className={cls.text} style={phone ? undefined : { color: "var(--t2)" }}>{repair.text}</span> : null}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        <button type="button" className={cls.btn} data-testid={view.approved ? "record-reopen" : "record-approve"} disabled={pending || !onReview} onClick={() => run(view.approved ? "unapprove" : "approve")}>
          {view.approved ? "Reopen" : "Approve"}
        </button>
        {(repair.state === "auto" || repair.state === "hand") && repair.target ? (
          <button type="button" className={cls.btn} data-testid="record-unlink" disabled={pending || !onReview} onClick={() => run("unlink_repair")}>{repair.unlinkLabel}</button>
        ) : null}
        {repair.state === "none" && repair.target ? (
          <button type="button" className={cls.btn} data-testid="record-relink" disabled={pending || !onReview} onClick={() => run("link_repair", repair.target.inspectionNumber)}>{`Link to #${repair.target.inspectionNumber}`}</button>
        ) : null}
      </div>
      {message ? <span role="alert" data-testid="record-review-message" className={cls.note} style={phone ? undefined : { color: "var(--warn)" }}>{message}</span> : null}
    </div>
  );
}
